<h1 class="u-sr-only">{{ 'Profile.Menu.Compliance' | translate }}</h1>
<section class="c-section c-section--last u-no-pb" panel [isOpen]="true">
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Profile.Menu.Compliance' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card c-card--s5">
					<p class="c-text" style="font-size: 1.14em; margin: 15px 15px 8px 15px;">{{ 'Compliance_Assessment.Hero_Label' | translate }}</p>
				</div>

				<div class="c-text c-text--bold c-text--main c-text--lg" style="margin: 16px 0;">{{ 'Compliance_Assessment.Available_Assessments' | translate }}</div>

				<div class="o-grid o-grid--wrap compliance-assessment-grid" style="margin: 0 -15px">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up compliance-assessment-grid__cell">
						<section class="c-section c-section--open c-section--static c-section--fit@md-and-up u-no-pb" panel>
							<div class="c-section__content" style="margin-top: 15px;">
								<div class="c-card c-card--height-fit">
									<div class="c-content u-no-pv u-ost-md u-osb-md">
										<p class="c-text c-text--bold c-text--main">{{ 'Compliance_Assessment.Psr_Title' | translate }}</p>
										<p class="c-text" style="margin-top: 15px;">{{ 'Compliance_Assessment.Psr_Description' | translate }}</p>
									</div>
									<div class="programme-meta" style="margin-left: 18px;">
										<span style="display: inline-flex; align-items: center; gap: 4px; margin-right: 6px;">
											<svg style="width: 16px; height: 16px; fill: #999;" viewBox="0 0 24 24"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12z"/></svg>
											{{ 'Compliance_Assessment.Psr_Meta_Questions' | translate }}
										</span>
										<span style="display: inline-flex; align-items: center; gap: 4px; margin-right: 6px;">
											<svg style="width: 16px; height: 16px; fill: #999;" viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>
											{{ 'Compliance_Assessment.Psr_Meta_Time' | translate }}
										</span>
										<span style="display: inline-flex; align-items: center; gap: 4px;">
											<svg style="width: 16px; height: 16px; fill: #999;" viewBox="0 0 24 24"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
											{{ 'Compliance_Assessment.Psr_Meta_Cadence' | translate }}
										</span>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed u-no-p o-grid__cell--right" style="margin: auto 15px 15px auto;">
										<a id="launchComplianceAssessmentButton" (click)="vm.openComplianceLaunch()" class="c-button c-button--s1 c-button--fit">+ {{ 'Compliance_Assessment.Launch' | translate }}</a>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>

				<p class="c-text c-text--main" style="font-size: 1.2em; margin: 25px 2px 25px 2px;">{{ 'Compliance_Assessment.History' | translate }}</p>
				<card-created-surveys questionnaireCode="COMPLIANCE_ASSESSMENT" [pageSize]="100"></card-created-surveys>
			</div>
		</div>
	</div>
</section>
